import React from "react";
import MainFAQs from "./components/MainFAQs";
import HeaderCities from "./components/HeaderCities";
import ServicesSlider from "./components/ServicesSwipper";
import ReviewsSlider from "./components/ReviewsSlider";
import LazyImage from "./components/LazyImage";
import "./assets/css/home.css";

function App() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Your Full-Service Junk Removal Experts! Just Point, and We’ll Handle the Rest. Book Your Free Estimate Online Today—We’re Ready to Clear Out Your Junk!"
        />
        <link
          rel="preload"
          as="image"
          href="/assets/img/logo.webp"
          type="image/webp"
        />
        <link
          rel="preload"
          as="image"
          href="/assets/img/footerlogo.webp"
          type="image/webp"
        />
        <link rel="canonical" href="https://junkdroid.com/" />
        <title>Same-Day Junk Removal Services | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <HeaderCities />
      {/* Hero Section Start HERE */}
      <div className="container-fluid hero-bgimg trust-bgimg trust-video">
        {/* Black overlay layer */}
        <div className="video-overlay"></div>

        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          loading="lazy"
          className="bg-video"
          alt="Professional junk removal service removing unwanted items from a house."
        >
          <source src="/assets/img/junk-removal.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
        {/*  */}
        <div className="mobile-index-img"></div>
        <div className="container junk-container">
          <div className="row">
            <div className="col-lg-8 col-md-12">
              {/* <h3>
                Need junk removal fast? Junk Droid offers reliable same-day
                pickup for residential, office, and commercial properties—always
                professional and affordable.
              </h3> */}
              {/* <h2>Top Junk Removers in the South Bay</h2> */}
              <h1>Junk Removal Services</h1>
              <p>
                Need junk removal fast? Junk Droid offers reliable same-day
                pickup for residential, office, and commercial properties—always
                professional and affordable.
              </p>
              <div className="row">
                <div className="col-lg-5 col-md-12">
                  <a href="tel:4085397261">
                    <button type="button" className="btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-telephone-fill"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                        />
                      </svg>{" "}
                      &nbsp; CALL NOW
                    </button>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-12" />
          </div>
        </div>
      </div>

      {/* Hero Section End HERE */}
      {/* yellow banner section start from here */}
      <div className="container-fluid yellow-desc hero-yellow-sec">
        <div className="col-md-12">
          <p>Free Estimates &amp; Same-Day Service Available</p>
        </div>
      </div>
      {/*  yellow banner section ended from here */}
      {/* Card Section Start HERE */}
      <div className="container-fluid">
        <div className="container junk-container pb-0 service-sec full-services-sec">
          <div className="row">
            <div className="col-md-12 services-cards-sect">
              <div className="d-flex flex-column">
                <h6 className="mt-0">What We Do</h6>
                <h2 className="full-head">Full Service Junk Removal</h2>
                <div className="line-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ServicesSlider />
      </div>
      {/* Card Section End HERE */}
      {/* Leave Junk Section Start From HERE */}
      <div className="container-fluid leave-junk-pros">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-12 junk-pros">
              <h2>Leave Junk Hauling to Pros</h2>
              <h6>Turning Clutter Into Clean Spaces, Every Time!</h6>
              <div class="sliderline-svg junk-line">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="4"
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  ></path>
                </svg>
              </div>
              <h3>Free Estimates</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                You’ll always get a free, no-obligation estimate before any work
                begins
              </p>
              <h3>Same-Day or Next-Day Service</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                Perfect for homes and businesses looking to remove junk, our
                service keeps your space tidy and ready to use.
              </p>
              <h3>Five Star Service Guarantee</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                If you're not completely satisfied with any aspect of our
                service, please inform us, and we’ll make every effort to
                resolve the issue promptly.
              </p>
              <h3>Professional Junk Haulers</h3>
              <div className="sliderline-svg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={64}
                  height={4}
                  viewBox="0 0 64 4"
                  fill="none"
                >
                  <path
                    d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                    fill="#60BDFF"
                  />
                </svg>
              </div>
              <p>
                Our team consists of skilled, highly trained, and certified junk
                removal professionals equipped to handle any job. They are
                dedicated to delivering an exceptional customer experience every
                time.
              </p>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="d-flex flex-column gap-5">
                <LazyImage
                  src="/assets/img/rubbish-removal.webp"
                  alt="leave junk"
                />
                <LazyImage
                  src="/assets/img/junk-removal.webp"
                  alt="leave junk"
                  className="clean-junk"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Leave Junk Section Ended From HERE */}
      {/* Top Rated Reviews Section Start HERE */}
      <ReviewsSlider />
      {/* Top Rated Reviews Section End HERE */}
      {/* FAQ's Section Start HERE */}
      <div className="container-fluid faqs-junk">
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Frequently <span>Asked Questions</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              {/* FAQ */}
              <MainFAQs />
              {/* FAQ */}
            </div>
          </div>
        </div>
        {/* Booking Section Start From Here */}
        <div className="container upr-footer up-footer booking-footer">
          <div className="row">
            <div className="col-md-12">
              <h2>Book Online and Save $20</h2>
              <h6>
                We’ll do&nbsp;all the lifting and loading, plus clean
                up&nbsp;any mess afterwards
              </h6>
              <center>
                <a href="/book-online/">
                  <button type="button" className="btn up-footer-btn">
                    SCHEDULE ONLINE &nbsp;
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-calendar"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                    </svg>
                  </button>
                </a>
              </center>
            </div>
          </div>
        </div>
        {/* Booking Section Ended From Here */}
      </div>
      {/* FAQ's Section End HERE */}
    </div>
  );
}

export default App;
